import { Configuration, ConfigurationResponse, SingleProjectResponse } from './configuration.model';
import DeviceType from './device.type';

export const mapSingleProject = (
  project: SingleProjectResponse,
  appId: string,
  channelsAccount: string
): Configuration => ({
  projectId: project.id,
  domainName: project.domain.name,
  allowSubdomains: project.domain.allowSubdomains,
  webhookUrl: project.webhookUrls.length && project.webhookUrls[0],
  appId,
  channelsAccount,
  active: project.active,
  displayOnDeviceType: project.displayOnDeviceType || DeviceType.ALL,
  displayConditionsEnabled: project.displayConditionsEnabled,
  displayConditionsLogicalOperator: project.displayConditionsLogicalOperator,
  displayConditions: project.displayConditions || [],
  channelsProjectId: project.channelsProjectId,
  timeBetweenSubmittedPopups: project.timeBetweenSubmittedPopups / 60,
  timeBetweenShownPopups: project.timeBetweenShownPopups / 60,
  activeType: project.activeType,
  name: project.name,
  workingHours: project.workingHours || { enabled: false, ranges: [] },
  ignoreDisplayLimit: project.ignoreDisplayLimit,
  popupStyle: project.popup ? project.popup.style : {},
  bubbleStyle: project.bubble ? project.bubble.style : {},
  afterClickMode: project.afterClickMode || 'WEB_CALL'
});

export const mapResponse = (data: ConfigurationResponse, projectId?: number): Configuration => {
  const { projects } = data.leadGeneration;
  const project = projectId ? projects.find(p => p.id === projectId) : projects[0];
  return mapSingleProject(project, data.appId, data.channelsAccount);
};
